<script>
  import { onMount, afterUpdate } from 'svelte';
  import Paper, { Title, Subtitle, Content as PaperContent } from '@smui/paper';
  import Card, { Content, Actions, ActionIcons } from '@smui/card';
  import Button, { Label, Icon } from '@smui/button';
  import IconButton from '@smui/icon-button';
  import moment from 'moment';
  import { fade } from 'svelte/transition';

  export let popup;
  export let basket;
  export let order;
  export let venue;

  $: items = order ? order.items : {};

  const sort_menu_items = (items) => items.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));

  const orderSequence = { main: 1, side: 2, dessert: 3, drink: 4 };
  const sort_categories = (items) => items.sort((a, b) => orderSequence[a.name] - orderSequence[b.name]);

  let ready = false;
  onMount(() => {
    ready = true;
  });

  const checkPreOrder = (start_time) => {
    const now = moment();
    const beginingOfDay = moment(start_time).startOf('day').add(1, 'minute');
    return now < beginingOfDay ? false : true;
  };
</script>

<div class="menu-container" style="margin: {popup.menu_ordering_active ? '50px 0 0 29px' : '50px auto 0 auto'}" transition:fade>
  {#if popup && ready}
    <div class="vendor-header">
      <div class="vendor-logo">
        <div style="background: url({popup.logo_image}) center/contain
          no-repeat" />
      </div>
      <div class="title"><span>{popup.vendor_name}</span></div>
    </div>

    {#if popup.menu_blurb}
      <div class="blurb">{@html popup.menu_blurb}</div>
    {/if}

    <hr />

    <p class="blurb" style="font-weight: bold; font-family: Manrope;">Orders can be placed only on the day of this event</p>

    {#if venue['onsite_contact_number']}
      <p class="blurb">Onsite contact tel: {venue['onsite_contact_number']}</p>
    {/if}

    <div>
      <!-- {#each popup.menu as menu_group} -->
      {#each sort_categories(popup.menu) as menu_group}
        <div class="group">
          <div class="category">{menu_group.name}s</div>
          <hr class="separator" />
        </div>

        {#each sort_menu_items(menu_group.menu_items).reverse() as menu_item, item_num}
          {#each menu_item.variations as variation}
            {#if item_num > 0}
              <hr class="separator" />
            {/if}
            <div class="menu-item">
              <div class="left">
                <div class="price">&pound;{variation.amount}</div>
                {#if popup.menu_ordering_active}
                  <div class="order-buttons {checkPreOrder(popup.start_time) ? '' : 'order-buttons--disabled'}">
                    <button class="add-remove remove" on:click={() => basket.removeItem(popup.id, variation.id)} disabled={!items[variation.id]} />
                    <span class="item-count">
                      {items[variation.id] ? items[variation.id].count : 0}
                    </span>
                    <button class="add-remove add" on:click={() => basket.addItem(popup.id, variation.id)} />
                  </div>
                {/if}
              </div>
              <div class="right">
                <div class="item-name">{menu_item.name}</div>
                <div class="item-description">
                  {#if menu_item.description}{menu_item.description || ''}{/if}
                </div>
                <div class="flags">
                  {#if menu_item.flags && menu_item.flags.length > 0}
                    {#each menu_item.flags as flag}
                      <div alt={flag} class="flag" style="background: url(/flags/{flag}.svg) center no-repeat" />
                    {/each}
                  {/if}
                </div>
              </div>
            </div>
          {/each}
        {/each}
      {/each}
    </div>
  {/if}
</div>

<style>
  .menu-container {
    width: 60%;
  }

  @media screen and (max-width: 768px) {
    .menu-container {
      width: 100% !important;
      margin-left: 0 !important;
    }
  }

  .title {
    display: flex;
    height: 60px;
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 38px;
    align-items: center;
    text-align: center;
    justify-content: center;
  }

  .blurb {
    font-family: Helvetica;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 140%;
    /* or 22px */
    letter-spacing: -0.01em;
    text-align: left;
  }

  .group {
    display: flex;
    align-items: flex-start;
    margin-bottom: 21px;
    margin-top: 21px;
  }

  .category {
    background: #3d3b3b;
    padding: 1px 6px;
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 140%;
    margin-right: 20px;
    text-transform: capitalize;
    color: #ffffff;
  }

  .separator {
    margin-top: 28px;
    margin-bottom: 47px;
  }

  .group .separator {
    margin-top: 5px;
    margin-bottom: 0px;
    flex: 1;
  }

  .card {
    margin-top: 20px;
  }

  .menu-item {
    display: flex;
  }

  .right {
    margin-left: 30px;
  }

  .left {
    display: flex;
    flex-direction: column;
    margin-bottom: 36px;
  }

  .price {
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    /* identical to box height */

    display: flex;
    align-items: center;
  }

  .order-buttons {
    display: flex;
    width: 74px;
    height: 28px;
    padding: 0;
    align-items: center;
    border: 1px solid black;
    background: black;
    margin-top: 11px;
  }

  .order-buttons--disabled {
    opacity: 0.25;
    pointer-events: none;
  }

  .add-remove {
    margin: 0;
    border: 0;
    border-radius: 0;
    padding: 0;
    color: white;
    width: 21px;
    height: 28px;
    cursor: pointer;
  }

  .add {
    background: url('/add.svg') center no-repeat;
  }

  .remove {
    background: url('/remove.svg') center no-repeat;
  }

  .item-count {
    background: white;
    font-family: Helvetica;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    height: 100%;
    text-align: center;
    line-height: 32px;
    flex: 1;
    align-items: center;
  }

  .item-name {
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    /* identical to box height */

    display: flex;
    align-items: center;
  }

  .item-description {
    margin-top: 11px;
    font-family: Helvetica;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 140%;
    /* or 22px */
    letter-spacing: -0.01em;
    text-align: left;
  }

  .flags {
    display: flex;
    margin-top: 10px;
    min-height: 22px;
  }

  .flag {
    width: 23px;
    height: 22px;
    margin-right: 10px;
  }

  .vendor-header {
    position: relative;
    width: 100%;
  }

  .vendor-logo {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -105%);
    width: 120px;
    height: 120px;
    border-radius: 60px;
    box-shadow: 1px 1px 2px gray, 0px 1px 2px gray, -1px 1px 2px gray;
    background-color: white;
    overflow: hidden;
  }
  .vendor-logo div {
    width: 100%;
    height: 100%;
    z-index: 10;
    position: relative;
  }
</style>
